import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';
import routes from '../routes';

export type SiteSection = 'horses' | 'carting';

export interface NavLinkItem {
  label: string;
  route: string;
}

const horsesNavLinks: NavLinkItem[] = [
  { label: 'HÄSTARNA', route: routes.HORSES },
  { label: 'NYHETER', route: routes.NEWS },
  { label: 'ANLÄGGNINGEN', route: routes.FACILITY },
  { label: 'TJÄNSTER', route: routes.SERVICES },
  { label: 'KONTAKT', route: routes.CONTACT },
];

const cartingNavLinks: NavLinkItem[] = [
  { label: 'HEM', route: routes.CARTING_HOME },
  // Add more carting-specific routes here as they're created
];

export const navLinksBySection: Record<SiteSection, NavLinkItem[]> = {
  horses: horsesNavLinks,
  carting: cartingNavLinks,
};

export const homeRouteBySection: Record<SiteSection, string> = {
  horses: routes.HOME,
  carting: routes.HOME,
};

interface SiteContextValue {
  section: SiteSection | undefined;
  setSection: (section: SiteSection) => void;
  navLinks: NavLinkItem[];
  homeRoute: string;
}

const SiteContext = createContext<SiteContextValue | null>(null);

interface SiteProviderProps {
  children: ReactNode;
}

export const SiteProvider: React.FC<SiteProviderProps> = ({ children }) => {
  const [section, setSectionState] = useState<SiteSection>(undefined);

  const setSection = useCallback((newSection: SiteSection) => {
    setSectionState(newSection);
  }, []);

  const navLinks = section ? navLinksBySection[section] : [];
  const homeRoute = section ? homeRouteBySection[section] : routes.HOME;

  return (
    <SiteContext.Provider value={{ section, setSection, navLinks, homeRoute }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSiteContext = (): SiteContextValue => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSiteContext must be used within a SiteProvider');
  }
  return context;
};

export default SiteContext;

